exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pix-range-input {\r\n  width: 100%;\r\n}\r\n\r\n.pix-range-input__separator{\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  line-height: 1.2;\r\n  color: #404040;\r\n}\r\n\r\n.pix-range-input__input-wrapper {\r\n  display: flex;\r\n  gap: 16px;\r\n  padding: 5px 10px;\r\n  background: #fff;\r\n  box-shadow: none;\r\n  transition: all .2s ease-in;\r\n}\r\n\r\n.pix-range-input__input-wrapper--invalid {\r\n  box-shadow: 0px 0px 0px 3px #e3061380;\r\n}\r\n\r\n.pix-range-input__input-wrapper input {\r\n  width: 50%;\r\n  outline: none;\r\n  border: none;\r\n  border-bottom: solid 1px #626468;\r\n  border-radius: 5px 5px 0px 0px;\r\n}", ""]);

// exports
